import React from 'react';
import { Table, Popconfirm, Button, Input, message } from 'antd';
import jquery from 'jquery';
import API_URL from '../../common/url';
import Sider from './SiteSider';
import $ from '../../common/AjaxRequest';
import AddCRA from "./AddCRA";
import EditCRA from "./EditCRA";

class CRA extends React.Component {
    state = {
        loading: false,
        pagination: {
            pageSize: 15,
            current: 1,
        },
        dataList: [],
        searchSiteCode: '',
        searchSiteName: '',
        searchUserName: '',
        craVisible: false,
        editCraVisible: false,
        editCraInfo: {},
        mobile: '',
    }

    componentDidMount() {
        this.loadData();
        this.queryInvestigationStageByInvId();
    }

    loadData = (params = {}) => {
        this.setState({
            loading: true,
        });
        const { searchSiteCode, searchSiteName, searchUserName, mobile, pagination } = this.state;
        const options = {
            url: `${API_URL.user.queryCRAList}`,
            data: {
                offset: pagination.current,
                siteCode: searchSiteCode,
                siteName: searchSiteName,
                userName: searchUserName,
                userMobile: mobile,
                ...params,
                limit: pagination.pageSize,
            },
            dataType: 'json',
            doneResult: (data => {
                const { CRAList } = data.data;
                const pagination = { ...this.state.pagination };
                pagination.total = CRAList.totalCount;
                this.setState({
                    loading: false,
                    dataList: CRAList.datas,
                    pagination,
                });
            }),
            errorResult: (data => {
                this.setState({
                    loading: false,
                });
            }),
        };
        $.sendRequest(options);
    }

    del = (userId, invSiteId) => {
        const options = {
            url: `${API_URL.user.removeCRA}`,
            data: {
                userId,
                invSiteId,
            },
            dataType: 'json',
            doneResult: () => {
                message.success("删除成功");
                this.loadData();
            },
        };
        $.sendRequest(options);
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            }
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getColumns = () => {
        const columnNames = [
            {
                title: '中心编号',
                dataIndex: 'investigationSiteCode',
                key: 'investigationSiteCode',
                width: 100,
            }, {
                title: '中心名称',
                dataIndex: 'investigationSiteName',
                key: 'investigationSiteName',
                width: 150,
            }, {
                title: 'CRA姓名',
                dataIndex: 'userName',
                key: 'userName',
                width: 120,
            }, {
                title: '手机号码',
                dataIndex: 'mobile',
                key: 'mobile',
                width: 120,
            }, {
                title: '固定电话',
                dataIndex: 'telephone',
                key: 'telephone',
                width: 120,
            }, {
                title: '邮箱',
                dataIndex: 'email',
                key: 'email',
                width: 220,
            }
        ];
        const { curRole, invStatus, investigationSiteName } = sessionStorage;
        const disabled = invStatus == 'COMPLETED';
        if (!investigationSiteName && (curRole == 'PA' || curRole == 'PM' || curRole == 'CTA')) {
            columnNames.push({
                title: '操作',
                key: 'operation',
                width: 90,
                render: (text, record) => {
                    return (
                        <span>
                            <a disabled={disabled} onClick={() => this.editCra(record)}>修改</a>
                            <span className="ant-divider" />
                            <Popconfirm title={'确定要删除吗?'} onConfirm={this.del.bind(this, record.userId, record.investigationSiteId)} okText="确定" cancelText="取消">
                                <a disabled={disabled}>删除</a>
                            </Popconfirm>
                        </span>
                    );
                },
            });
        }
        return columnNames;
    }

    getDataSource = () => {
        const resList = [];
        const { dataList, pagination } = this.state;
        dataList.map((dataItem, i) => {
            resList.push({
                customerId: dataItem.customerId,
                userId: dataItem.userId,
                investigationSiteId: dataItem.investigationSite.investigationSiteId,
                investigationSiteCode: dataItem.investigationSite.investigationSiteCode,
                investigationSiteName: dataItem.investigationSite.investigationSiteName,
                userName: dataItem.userName,
                mobile: dataItem.mobile,
                telephone: dataItem.telephone,
                email: dataItem.email,
            });
        });
        return resList;
    }

    handleTableChange = (pagination, filters, sorter) => {
        let sortType,
            direction,
            sort = sort = sorter.field;
        const pager = { ...this.state.pagination };
        if (pager.current == pagination.current) {
            pager.current = 1;
            //排序则页码为1
        } else {
            pager.current = pagination.current;
            //获取当前页
        }
        if (!jquery.isEmptyObject(sorter) && sorter.column) {
            sortType = sorter.column.sortType;
        }
        if (sorter.order === 'descend') {
            direction = 'DESC';
        } else {
            direction = 'ASC';
        }
        this.setState({
            pagination: pager,//设置新的分页信息
            sortParams: {//设置排序信息
                direction,
                sort,
                sortType
            }
        });

        this.loadData({
            limit: pager.pageSize,
            offset: pager.current,
            direction,
            sort,
            sortType,
            ...this.state.searchParams,
            ...filters,
        });
    }

    onChangeSiteCode = e => {
        this.setState({ searchSiteCode: e.target.value });
    }

    onChangeSiteName = e => {
        this.setState({ searchSiteName: e.target.value });
    }

    onChangeUserName = e => {
        this.setState({ searchUserName: e.target.value });
    }

    search = () => {
        this.loadData();
    }

    onChangeMobile = e => {
        this.setState({ mobile: e.target.value });
    }

    searchComponent = () => {
        const { curRole, invState } = sessionStorage;
        if (invState != 2) {
            const { searchSiteCode, searchSiteName, searchUserName, mobile } = this.state;
            const element = (
                <div className="filter-bar">
                    <div className="form-item">
                        <label className="ui-label">中心编号</label>
                        <Input
                            value={searchSiteCode}
                            onChange={this.onChangeSiteCode}
                        />
                    </div>
                    <div className="form-item">
                        <label className="ui-label">中心名称</label>
                        <Input
                            value={searchSiteName}
                            onChange={this.onChangeSiteName}
                        />
                    </div>
                    <div className="form-item">
                        <label className="ui-label">CRA姓名</label>
                        <Input
                            value={searchUserName}
                            onChange={this.onChangeUserName}
                        />
                    </div>
                    <div className="form-item">
                        <label className="ui-label">手机号</label>
                        <Input
                            value={mobile}
                            onChange={this.onChangeMobile}
                        />
                    </div>
                    <Button type="primary" onClick={this.search}>搜索</Button>
                    {
                        invState == 3 && (curRole == "PA" || curRole == "PM" || curRole == "CTA") && <Button type="primary" onClick={this.add}>添加</Button>
                    }
                </div>
            );
            return element;
        } else if (curRole == "CRC") {
            const element = (
                <div className="filter-bar" style={{ display: "block" }}>
                    <Button style={{ float: "right" }} type="primary" onClick={() => this.canEditByInvStatus(() => this.add())}>添加</Button>
                </div>
            );
            return element;
        }
        return null;
    }

    add = () => {
        this.changeCraVisible(true);
    }

    editCra = (cra) => {
        this.setState({
            editCraVisible: true,
            editCraInfo: cra,
        })
    }

    changeCraVisible = (value) => {
        this.setState({ craVisible: value })
    }

    changeEditCraVisible = (value) => {
        this.setState({ editCraVisible: value })
    }

    render() {
        const { loading, pagination, craVisible, editCraVisible, editCraInfo } = this.state;
        return (
            <div className="content">
                <Sider selectKey='siteCra' />
                <div className="main">
                    {this.searchComponent()}
                    <div className="main-content">
                        <Table
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.customerId}
                            loading={loading}
                            onChange={this.handleTableChange}
                            pagination={pagination}
                        />
                    </div>
                </div>
                <AddCRA changeCraVisible={this.changeCraVisible} visible={craVisible} reload={this.loadData} />
                <EditCRA changeEditCraVisible={this.changeEditCraVisible} visible={editCraVisible} editCraInfo={editCraInfo} reload={this.loadData} />
            </div>
        );
    }
}

export default CRA;



// WEBPACK FOOTER //
// ./src/components/site/CRA.js